/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 17:15:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 16:11:33
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/ProductCategory/Card/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import { useDispatch } from 'react-redux';
import { postProductsMove } from '../slice';
import Table from '../Table';
import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import Top from 'src/pages/SalesChannelCategory/Components/Card';

const Card = (props) => {
  const _d = useDispatch();
  const {
    uuid,
    products = [],
    name,
    slug,
    moveList,
    isRoot,
    parent,
    url,
    salesChannelUuid,
    userPermissions,
    onEdit,
  } = props;

  const handleOnProductMove = (e) => {
    const { target, productsUuid } = e;
    _d(
      postProductsMove({
        body: {
          salesChannelUuid,
          targetUuid: target,
          itemUuids: productsUuid,
        },
      }),
    );
  };

  return (
    <React.Fragment>
      <SectionContent hasBottomBorder>
        <Top
          parent={parent}
          url={url}
          isRoot={isRoot}
          name={name}
          slug={slug}
          canEdit={userPermissions.canCreate}
          onEdit={onEdit}
        />
      </SectionContent>
      <SectionContent hasBottomBorder className={css.tableContainer}>
        <Table
          canMove={userPermissions.canCreate}
          onMove={handleOnProductMove}
          uuid={`root${uuid}`}
          data={products}
          moveList={moveList}
        />
      </SectionContent>
    </React.Fragment>
  );
};
export default Card;
// HOC(Card, {
//   getCollapse,
//   getContent: getRoot,
//   title: 'Root',
//   onCollapseChange,
//   getLoaded,
// });
